import React from 'react'
import Select from 'react-select';
import { makeDarkSelectStyles } from '../selectStyles';

export default function SelectPeriod({ callback, value, width }) {

    const customStyles = makeDarkSelectStyles({ width: width || '100px' });

    const periods_array = range(1, 21);

    function range(start, end) {
        var foo = [];
        for (var i = start; i <= end; i++) {
            foo.push(i);
        }
        return foo;
    }
    var options = []
    Array.from(periods_array, (e, i) => {
        var option = null;
        option = {
            label: periods_array[i],
            value: i+1
        }
        options.push(option)
    })

    const handleSelect = (e) => {
        value = e.value;
        callback(value, "period")

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="Episode"
                    value={options && options.filter(obj => obj.value == value)}
                />
            </div>

        </>
    )
}
